<script setup>
import StatCard from "@/Components/PayPeriod/StatCardComponent.vue";
import PayPeriodPerson from "@/Components/Disbursements/PayPeriodPersonComponent.vue";
import MyPayPeriodInitialComponent from "@/Components/HoldBacks/MyPayPeriodInitialComponent.vue";
import MyPayPeriodReleasedComponent from "@/Components/HoldBacks/MyPayPeriodReleasedComponent.vue";
import AdjustmentsComponent from "@/Components/Adjustments/AdjustmentsComponent.vue";
import StatCardComponent from "@/Components/PayPeriod/StatCardComponent.vue";
import MarketingPayComponent from "@/Components/PayPeriod/MarketingPayComponent.vue";
import {useRoute} from "vue-router";
import {Permissions} from "@/Utils/Permissions";
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
const route = useRoute()

const data = reactive({
  loading: true,
  exists: false
});

const checkExists = () => {
  data.loading = true;
  data.exists = false;
  ApiWrapper.post('pay-period', 'pay-period-exists', {
    payPeriodId: route.params.id
  })
      .then((response) => {
        data.exists = true;
      })
      .catch((e)=>{
        data.exists = false;
      })
      .finally(()=>{
        data.loading = false;
      });

}
onMounted(() => {
  if(route.params.id === 'Pending' || route.params.id === 'pending') {
    data.loading = false;
    data.exists = true;
  }
  else {
    checkExists();
  }
});


</script>

<template>
  <template v-if="data.loading">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-skeleton-loader type="card"></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && !data.exists">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-alert title="Not Found" text="The specified pay period could not be found" type="error"></v-alert>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && data.exists">
    <v-row v-if="Permissions.checkPermissions(['my-pay-period.pay-period'])">
      <v-col cols="12">
        <StatCard :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['my-pay-period.disbursement'])">
      <v-col cols="12">
        <PayPeriodPerson :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['my-pay-period.initial-holdbacks'])">
      <v-col cols="12">
        <MyPayPeriodInitialComponent :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['my-pay-period.released-holdbacks'])">
      <v-col cols="12">
        <MyPayPeriodReleasedComponent :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['my-pay-period.adjustments'])">
      <v-col cols="12">
        <AdjustmentsComponent :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['my-pay-period.marketing-pay'])">
      <v-col cols="12">
        <MarketingPayComponent :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
  </template>
</template>

<style scoped>

</style>